<template>
    <div class="mt-6 content">
        <h3 class="has-text-white"><i class="fad fa-fw fa-memo-pad mr-3"></i>Online Course Notes</h3>

<!--        <p class="mt-6 has-text-white"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading course...</p>-->

        <div class="mt-6 pb-6">
            <ui-card class="pt-0 pl-4 pr-6">
                <div class="columns is-gapless mb-6 pt-5">
                    <div class="column is-narrow"><i class="far fa-fw fa-info-circle mr-2"></i></div>
                    <div class="column">
                        <div class="has-text-weight-bold">This course does not have online notes.</div>
                    </div>
                </div>
            </ui-card>
        </div>
    </div>
</template>

<script>
    import {client as http} from "../../http_client";
    import moment from "moment";
    import UiCard from "../../components/UiCard";

    export default {
        components: {UiCard},
        props: ['enrollmentId'],
        data: function() {
            return {

            };
        },
        computed: {

        },
        methods: {

        },
        mounted() {
        }
    };
</script>

<style scoped>

</style>
